<template>
  <div class="container">
    <div :class="{ banner: true, showBtn: btnFlage }">
      <div class="swiper-container bannerSwiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in bannerList"
            :key="index + 'qua'"
          >
            <img :src="item.photo" width="100%" height="auto" />
          </div>
        </div>
        <div class="swiper-button-prev"></div>
        <!--左箭头。如果放置在swiper外面，需要自定义样式。-->
        <div class="swiper-button-next"></div>
        <!--右箭头。如果放置在swiper外面，需要自定义样式。-->
        <div class="swiper-pagination"></div>
        <!--分页器。如果放置在swiper外面，需要自定义样式。-->
      </div>
    </div>

    <!-- 主页第二板块，信息部分 -->
    <div class="home_page_two_side">
      <div class="two_side_title" id="title">
        专注于政企信息化、智慧水土解决方案的高科技
      </div>
      <div class="two_side_content">
        <p>
          武汉芸希信息科技有限公司，是一家专注于政企信息化、智慧水土解决方案的高科技企业。
        </p>
        <p>
          致力于政企信息化、数字化转型，围绕生物医药、地质岩土、教育培训等行业提供信息化、智慧解决方案。
        </p>
        <p>
          公司的3位创始人毕业于武汉大学、华中科技大学，在华为/烽火工作近10年，拥有资深的行业经验。
        </p>
      </div>
    </div>

    <!-- 主页第三板块，产品服务 -->
    <div class="home_page_three_side">
      <div class="three_side_title" id="title">产品服务</div>
      <div class="three_side_int">
        让每一步操作都合理且舒适，给用户优化的体验
      </div>
      <div class="three_side_contnet">
        <img
          src="../../assets/yunthee/home_page_three_side_bg.png"
          width="100%"
          height="auto"
        />
        <div class="three_side_contnet_assets">
          <div class="three_side_contnet_title">资产管理系统</div>
          <div class="three_side_contnet_int">
            资产管理系统是以实物管理为基础,以计算机为操作平台,以“快捷”、“精准”和功能全面为优势的面向资产的管理类系统。
          </div>
        </div>
        <div class="three_side_contnet_data">
          <div class="three_side_contnet_title">数字孪生系统</div>
          <div class="three_side_contnet_int">
            充分利用物理模型、传感器更新、运行历史等数据，集成多学科、多物理量、多尺度、多概率的仿真过程。
          </div>
        </div>
        <div class="three_side_contnet_work">
          <div class="three_side_contnet_title">办公协同系统</div>
          <div class="three_side_contnet_int">
            将现代化办公和计算机网络功能结合起来的一种新型的办公方式。
          </div>
        </div>
        <div class="three_side_contnet_party">
          <div class="three_side_contnet_title">党建管理系统</div>
          <div class="three_side_contnet_int">
            通过互联网大数据技术，实现了党务管理、党员管理、党组织管理、党员考核等党务工作的线上办公，不受时间、地点的约束，支持随地随地开展.
          </div>
        </div>
        <div class="three_side_contnet_software">
          <div class="three_side_contnet_title">软件定制开发</div>
          <div class="three_side_contnet_int">
            指企业管理软件的定制，企业管理软件是指能够体现企业管理的大部分职能
          </div>
        </div>
      </div>
    </div>

    <!-- 主页第四板块，解决方案 -->
    <div class="home_page_four_side">
      <div class="four_side_title" id="title">解决方案</div>
      <div class="four_side_contnet">
        <div class="four_content_item">
          <div class="four_item_img">
            <img
              src="../../assets/yunthee/four_content_item_bg_01.png"
              width="100%"
              height="auto"
            />
            <div class="four_item_hover">
              <div class="four_hover_icon">
                <img
                  src="../../assets/yunthee/four_hover_icon.png"
                  width="100%"
                  height="100%"
                />
              </div>
              <div class="four_hover_content">
                <p>
                  将现代化办公和计算机网络功能结合起来的一种新型的办公方式。
                </p>
              </div>
            </div>
          </div>
          <div class="four_item_title">智慧地灾解决方案</div>
        </div>
        <div class="four_content_item">
          <div class="four_item_img">
            <img
              src="../../assets/yunthee/four_content_item_bg_02.png"
              width="100%"
              height="auto"
            />
            <div class="four_item_hover">
              <div class="four_hover_icon">
                <img
                  src="../../assets/yunthee/four_hover_icon.png"
                  width="100%"
                  height="100%"
                />
              </div>
              <div class="four_hover_content">
                <p>
                  将现代化办公和计算机网络功能结合起来的一种新型的办公方式。
                </p>
              </div>
            </div>
          </div>
          <div class="four_item_title">智慧矿山解决方案</div>
        </div>
        <div class="four_content_item">
          <div class="four_item_img">
            <img
              src="../../assets/yunthee/four_content_item_bg_03.png"
              width="100%"
              height="auto"
            />
            <div class="four_item_hover">
              <div class="four_hover_icon">
                <img
                  src="../../assets/yunthee/four_hover_icon.png"
                  width="100%"
                  height="100%"
                />
              </div>
              <div class="four_hover_content">
                <p>
                  将现代化办公和计算机网络功能结合起来的一种新型的办公方式。
                </p>
              </div>
            </div>
          </div>
          <div class="four_item_title">智慧水务解决方案</div>
        </div>
      </div>
    </div>

    <!-- 主页第五板块，客户案例 -->
    <div class="home_page_five_side">
      <div class="five_side_title" id="title">客户案例</div>
      <div class="five_side_content">
        <div class="swiper-container coopCase">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in caseList"
              :key="index + 'case'"
            >
              <div class="caseImgBox">
                <img :src="item.cover" width="100%" height="100%" />
                <div class="caseHoverBox">{{ item.hover }}</div>
              </div>

              <div class="caseContnet">
                <div class="caseCntTitle">
                  {{ item.title }}
                </div>
                <div class="caseContentMain">
                  {{ item.introduction }}
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev"></div>
          <!--左箭头。如果放置在swiper外面，需要自定义样式。-->
          <div class="swiper-button-next"></div>
          <!--右箭头。如果放置在swiper外面，需要自定义样式。-->
        </div>
      </div>
    </div>

    <!-- 主页第六板块，我们的优势 -->
    <div class="home_page_six_side">
      <div class="six_side_title" id="title">我们的优势</div>
      <div class="six_side_tip">让每一步操作都合理且舒适，给用户优化的体验</div>
      <div class="six_side_content">
        <div class="six_content_item">
          <div class="six_item_img">
            <img
              src="../../assets/yunthee/six_content_item_01.png"
              width="78px"
              height="84px"
            />
          </div>
          <div class="six_item_title">经验丰富</div>
          <div class="six_item_line">
            <img
              src="../../assets/yunthee/six_item_line.png"
              width="100%"
              height="100%"
            />
          </div>
          <div class="six_item_content">
            智慧党建管理平台具备多端口、跨屏幕、移动化的优势，支持用户通过电脑、手机、微信小程序等多端访问，操作简单、方便、快捷。
          </div>
        </div>
        <div class="six_content_item">
          <div class="six_item_img">
            <img
              src="../../assets/yunthee/six_content_item_02.png"
              width="78px"
              height="84px"
            />
          </div>
          <div class="six_item_title">敏捷高效</div>
          <div class="six_item_line">
            <img
              src="../../assets/yunthee/six_item_line.png"
              width="100%"
              height="100%"
            />
          </div>
          <div class="six_item_content">
            满足不同个性化定制需求，随需而变，实用性强
          </div>
        </div>
        <div class="six_content_item">
          <div class="six_item_img">
            <img
              src="../../assets/yunthee/six_content_item_03.png"
              width="75px"
              height="86px"
            />
          </div>
          <div class="six_item_title">交付完整</div>
          <div class="six_item_line">
            <img
              src="../../assets/yunthee/six_item_line.png"
              width="100%"
              height="100%"
            />
          </div>
          <div class="six_item_content">
            满足不同个性化定制需求，随需而变，实用性强
          </div>
        </div>
        <div class="six_content_item">
          <div class="six_item_img">
            <img
              src="../../assets/yunthee/six_content_item_04.png"
              width="113px"
              height="103px"
            />
          </div>
          <div class="six_item_title">管家式售后</div>
          <div class="six_item_line">
            <img
              src="../../assets/yunthee/six_item_line.png"
              width="100%"
              height="100%"
            />
          </div>
          <div class="six_item_content">安全防护体系，支持私有化部署</div>
        </div>
      </div>
    </div>

    <!-- 第七部分，合作客户 -->
    <div class="home_page_seven_side">
      <div class="seven_side_title" id="title">合作客户</div>
      <div class="seven_side_content">
        <div
          class="seven_content_item"
          v-for="(item, index) in 10"
          :key="'coop' + index"
        >
          <img
            :src="require('../../assets/yunthee/coop' + (index + 1) + '.png')"
          />
          <!-- <img src="../../assets/yunthee/coop1.png" /> -->
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
/* 轮播部分 */
.banner .swiper-container {
  width: 100%;
  height: auto;
}
.banner .swiper-container .swiper-wrapper {
  width: 100%;
  height: auto;
}
.banner .swiper-container .swiper-wrapper .swiper-slide {
  width: 100%;
  height: auto;
}
.banner .swiper-container {
  --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
  --swiper-navigation-color: rgba(161, 161, 161, 0.5); /* 单独设置按钮颜色 */
  --swiper-navigation-size: 50px; /* 设置按钮大小 */
  --swiper-pagination-color: rgba(255, 255, 255, 0.5); /* 两种都可以 */
  --swiper-pagination-size: 50px; /* 设置按钮大小 */
}

/* 第二部分 */
.home_page_two_side {
  width: 100%;
  height: 310px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.home_page_two_side .two_side_title {
  width: 50%;
  height: 50px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  font-family: PingFangSC, PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #333333;
}
.home_page_two_side .two_side_content {
  width: 50%;
  height: auto;
  margin: 30px auto 0 auto;
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: center;
  color: #707e8f;
}
.home_page_two_side .two_side_content p {
  margin: 8px;
}

/* 第三部分 */
.home_page_three_side {
  width: 100%;
  height: 975px;
  background: #f6f7fb;
  padding-top: 50px;
}
.three_side_title {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px auto;
  font-size: 36px;
  font-family: PingFangSC, PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #333333;
}
.three_side_int {
  width: 50%;
  height: 22px;
  margin: 0 auto;
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: center;
  color: #707e8f;
}
.three_side_contnet {
  width: 40%;
  height: auto;
  margin: 96px auto 0 auto;
  position: relative;
}
.three_side_contnet_assets {
  position: absolute;
  width: 40%;
  height: 200px;
  top: 0;
  left: -200px;
}
.three_side_contnet_data {
  position: absolute;
  width: 40%;
  height: 200px;
  top: 0;
  right: -220px;
}
.three_side_contnet_work {
  position: absolute;
  width: 40%;
  height: 200px;
  top: 280px;
  left: -320px;
}
.three_side_contnet_party {
  position: absolute;
  width: 40%;
  height: 200px;
  top: 280px;
  right: -300px;
}
.three_side_contnet_software {
  position: absolute;
  width: 40%;
  height: 200px;
  top: 620px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
.three_side_contnet_title {
  font-size: 24px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  color: #333333;
  line-height: 48px;
}
.three_side_contnet_int {
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #707e8f;
  line-height: 24px;
}

/* 第四部分 */
.home_page_four_side {
  width: 100%;
  height: 688px;
  background: url('../../assets/yunthee/home_page_four_side_bg.png') no-repeat;
  background-size: cover;
  padding-top: 50px;
}
.four_side_title {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px auto;
  font-size: 36px;
  font-family: PingFangSC, PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #333333;
}
.four_side_contnet {
  width: 60%;
  height: 547px;
  margin: 44px auto 0 auto;
  display: flex;
  justify-content: space-between;
}
.four_content_item {
  width: 25%;
  height: 457px;
}
.four_item_img {
  width: 100%;
  height: auto;
  position: relative;
  cursor: pointer;
}
.four_item_img:hover .four_item_hover {
  display: block;
}
.four_item_title {
  width: 100%;
  margin-top: 20px;
  text-align: center;
  font-size: 26px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 550;
  text-align: center;
  color: #2468f2;
}
.four_item_hover {
  width: 100%;
  height: 99%;
  background-color: rgba(48, 105, 228, 0.7);
  position: absolute;
  top: 0;
  border-radius: 5px;
  display: none;
}
.four_hover_icon {
  width: 58px;
  height: 58px;
  margin: 100px auto 0 auto;
}
.four_hover_content {
  width: 80%;
  margin: 0 auto;
  height: auto;
}
.four_hover_content p {
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
}

/* 第五部分 */
.home_page_five_side {
  width: 100%;
  height: 635px;
  background-color: #ffffff;
  padding-top: 50px;
}
.five_side_title {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px auto;
  font-size: 36px;
  font-family: PingFangSC, PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #333333;
}
.five_side_content {
  width: 60%;
  height: auto;
  margin: 50px auto 0 auto;
}

.five_side_content .swiper-container {
  width: 100%;
  height: auto;
}
.five_side_content .swiper-container .swiper-wrapper {
  width: 100%;
  height: auto;
}
.five_side_content .swiper-container .swiper-wrapper .swiper-slide {
  width: 100%;
  height: auto;
}
.five_side_content .swiper-container {
  --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
  --swiper-navigation-color: rgba(161, 161, 161); /* 单独设置按钮颜色 */
  --swiper-navigation-size: 15px; /* 设置按钮大小 */
  /* --swiper-pagination-color: rgba(255, 255, 255, 0.5); 两种都可以 */
  /* --swiper-pagination-size: 50px; 设置按钮大小 */
}
.five_side_content .swiper-button-prev {
  width: 30px;
  height: 30px;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0px 3px 6px 0px rgba(203, 203, 203, 0.16);
  position: absolute;
  top: 120px;
}
.five_side_content .swiper-button-next {
  width: 30px;
  height: 30px;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0px 3px 6px 0px rgba(203, 203, 203, 0.16);
  position: absolute;
  top: 120px;
}
.caseImgBox {
  width: 100%;
  height: 243px;
  position: relative;
  cursor: pointer;
}
.caseImgBox img {
  border-radius: 10px;
}
.caseHoverBox {
  width: 0;
  display: none;
  height: 243px;
  background-color: rgba(0, 37, 94, 0.7);
  position: absolute;
  top: 0;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 550;
  text-align: left;
  color: #ffffff;
  letter-spacing: 3.56px;
  border-radius: 10px;
}
.caseImgBox:hover .caseHoverBox {
  width: 100%;
  display: flex;
}
.caseContnet {
  width: 100%;
  height: 90px;
  margin-top: 30px;
}
.caseCntTitle {
  width: 100%;
  height: 33px;
  display: flex;
  align-items: center;
  font-size: 20px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 550;
  text-align: left;
  color: #033e80;
  letter-spacing: 2.38px;
}
.caseContentMain {
  margin-top: 10px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #4f5768;
  letter-spacing: 0.4px;
  width: 100%;
  height: auto;
}

/* 第六部分 */
.home_page_six_side {
  width: 100%;
  height: 635px;
  background: url('../../assets/yunthee/home_page_six_side_bgx.png') no-repeat;
  background-size: cover;
  padding-top: 50px;
}
.six_side_title {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px auto;
  font-size: 36px;
  font-family: PingFangSC, PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #333333;
}
.six_side_tip {
  width: 50%;
  margin: 10px auto 0 auto;
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: center;
  color: #707e8f;
}
.six_side_content {
  width: 60%;
  height: auto;
  margin: 50px auto 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.six_content_item {
  width: 22%;
  height: 370px;
  background: #ffffff;
  border: 1px solid #f6f7fb;
  border-radius: 10px;
  transform: scale(1) translateZ(0);
  transition: all 0.7s;
}
.six_content_item:hover {
  transform: translateZ(0) scale(1.2);
}
.six_item_img {
  width: 100%;
  height: 100px;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.six_item_title {
  margin-top: 15px;
  width: 100%;
  height: 33px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 550;
  text-align: left;
  color: #033e80;
}
.six_item_line {
  width: 24px;
  height: 4px;
  margin: 15px auto 0 auto;
}
.six_item_content {
  width: 80%;
  margin: 15px auto 0 auto;
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  color: #6f7d8e;
}

.home_page_seven_side {
  width: 100%;
  height: 635px;
  background-color: #ffffff;
  padding-top: 50px;
}
.seven_side_title {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px auto;
  font-size: 36px;
  font-family: PingFangSC, PingFangSC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #333333;
}
.seven_side_content {
  width: 60%;
  height: auto;
  margin: 50px auto 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-flow: wrap;
}
.seven_content_item {
  width: 18%;
  height: auto;
  margin-bottom: 29px;
}
.seven_content_item img {
  width: 100%;
  height: auto;
}
</style>

<script>
import axios from 'axios'
import Swiper from 'swiper'
import { indexCaseBanner, getBanner } from '@/api/apiCenter'
// setTimeout(() => {

// }, 500)
export default {
  data() {
    return {
      bannerList: [],
      caseList: [],
      btnFlage: false,
      bannerSwiper: undefined,
    }
  },
  mounted() {
    this.init()
    this.getCaseSwiper()
    this.backtop()
    window.addEventListener('scroll', this.handleScroll, true)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, true)
  },
  filters: {
    ellTitle(value) {
      if (!value) return ''
      if (value.length > 15) {
        return value.slice(0, 15) + '...'
      }
      return value
    },
    ellContent(value) {
      if (!value) return ''
      if (value.length > 40) {
        return value.slice(0, 40) + '...'
      }
      return value
    },
  },
  methods: {
    init() {
      let that = this
      // axios
      //   .get('http://www.thingo.com.cn/thingo-server/website/homePage/banner')
      //   .then((res) => {
      //     that.bannerList = res.data.data
      //     this.$nextTick(() => {
      //       this.initBannerSwiper()
      //     })
      //   })
      getBanner('index').then((res) => {
        that.bannerList = res.data.data
        this.$nextTick(() => {
          this.initBannerSwiper()
        })
      })
    },

    getCaseSwiper() {
      indexCaseBanner().then((res) => {
        this.caseList = res.data.data
        this.$nextTick(() => {
          this.initCaseSwiper()
        })
      })
    },

    backtop() {
      window.onbeforeunload = function () {
        window.scrollTo(0, 0)
      }
    },

    initBannerSwiper() {
      this.bannerSwiper = new Swiper('.bannerSwiper', {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loop: true,
        speed: 500,
        freeMode: true,
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      })
    },

    initCaseSwiper() {
      this.bannerSwiper = new Swiper('.coopCase', {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loop: true,
        speed: 500,
        freeMode: true,
        slidesPerView: 3,
        spaceBetween: 20,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })
    },

    handleScroll() {
      //   let scrollTop = document.documentElement.scrollTop
      //   let scrollWidth = document.body.scrollWidth
      //   let scrollHeight = document.body.scrollHeight
      //   let proportion = (scrollTop / scrollHeight) * 100
      //   if (scrollWidth > 1366) {
      //     if (proportion > 0.5 && this.adcontentFlage) {
      //     }
      //     if (proportion > 16 && this.caseFlage) {
      //     }
      //     if (proportion > 33 && this.coopFlage) {
      //     }
      //     if (proportion > 48 && this.evelFlage) {
      //     }
      //     if (proportion > 70 && this.realFlage) {
      //     }
      //   }
      //   if (scrollWidth > 1000 && scrollWidth <= 1366) {
      //     if (proportion > 0.5 && this.adcontentFlage) {
      //     }
      //     if (proportion > 10 && this.caseFlage) {
      //     }
      //     if (proportion > 29 && this.coopFlage) {
      //     }
      //     if (proportion > 48 && this.evelFlage) {
      //     }
      //     if (proportion > 70 && this.realFlage) {
      //     }
      //   }
      //   if (scrollWidth < 1000) {
      //     if (proportion > 0.2 && this.adcontentFlage) {
      //     }
      //     if (proportion > 20 && this.caseFlage) {
      //     }
      //     if (proportion > 35 && this.coopFlage) {
      //     }
      //     if (proportion > 50 && this.evelFlage) {
      //     }
      //     if (proportion > 65 && this.realFlage) {
      //     }
      //   }
    },
  },
}
</script>
